import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.districtValidation = function () {
    const dictonary = {
      custom: {
        Country: {
          required: () => t.t(dictEnum.LBL_Country) + t.t(dictEnum.WARN_IsRequired)
        },
        District: {
          required: () => t.t(dictEnum.LBL_District) + t.t(dictEnum.WARN_IsRequired)
        },
        AreaDesc: {
          required: () => t.t(dictEnum.LBL_Area) + " " + t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        },
        AreaChiDesc: {
          required: () => t.t(dictEnum.LBL_Area) + " " + t.t(dictEnum.LBL_ChiDesc) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080800-District/S080800-DistrictValidation.js